<template>
  <div>
    <!-- Reverse Factoring: supporting docs (receivable invoices) -->
    <div v-if="invoice.recourse == 2">
      <div class="col-12 alert alert-secondary p-2">
        <b-row>
          <!-- Supporting Docs -->
          <b-col cols="12" md="6">
            <div class="pb-0 font-weight-bolder">{{ $t("receivable_invoices") }}</div>
            <validation-provider
              #default="{ errors }"
              :name="$t('receivable_invoices') + ' ' + index"
              rules="required"
            >
              <b-form-file
                style="display: none"
                @change="uploadRecourseFile($event, 'receivable_invoices', index)"
                :placeholder="$t('upload_receivables_here')"
                drop-placeholder="Drop file here..."
                ref="fileInput5"
                id="fileInput5"
                v-model.trim="invoice.supporting_docs"
                multiple
                required
              ></b-form-file>
              <div
                class="col-12 pl-0 pt-2 text-danger"
                v-if="supportingDocsFilesMissing"
              >
                {{ $t("required_field") }}
              </div>
            </validation-provider>

            <div class="mt-1 mr-0 pr-0">
              <b-alert show variant="info" class="col-md-12">
                <b-row class="col-md-12">
                  <b-col
                    class="col-md-12 mt-2 mb-2 text-center pointer"
                    @click="triggerFileInput5"
                  >
                    <div>
                      <feather-icon icon="DownloadIcon" size="25" />
                      <span></span>
                      {{ $t("upload_receivables_here") }}
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <ul>
                <li v-for="(name, i) in filesNameSupporting" :key="i">
                  {{ name }}
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Non‑Recourse specific documents -->
    <div v-else-if="invoice.recourse == 0">
      <div class="col-12 alert alert-secondary p-2">
        <template>
          <b-row class="mt-1">
            <b-col md="6" class="mt-1">
              <div class="pb-0 font-weight-bolder">
                {{ $t("annual_financial_statements") }}
                <span class="text-danger asterik-size">*</span>
              </div>
              <b-form-file
                style="display: none"
                @change="uploadRecourseFile($event, 'annual_financial_statements', index)"
                :placeholder="$t('upload_files_here')"
                drop-placeholder="Drop file here..."
                :ref="'fileInputAFS' + index"
                :id="'fileInputAFS' + index"
                v-model.trim="invoice.annual_financial_statements"
                multiple
              ></b-form-file>
              <div class="mt-1 mr-0 pr-0">
                <b-alert show variant="info" class="col-md-8">
                  <b-row class="col-md-12">
                    <b-col
                      class="col-md-12 mt-2 mb-2 text-center pointer"
                      @click="triggerFileInputAFS(index)"
                    >
                      <div>
                        <feather-icon icon="DownloadIcon" size="25" />
                        <span></span>
                        {{ $t("upload_files_here") }}
                      </div>
                    </b-col>
                  </b-row>
                </b-alert>
                <ul>
                  <li
                    v-for="(name, i) in filesNameAnnualFinancialStatements"
                    :key="i"
                  >
                    {{ name }}
                  </li>
                </ul>
                <div
                  class="col-12 pl-0 text-danger"
                  v-if="nonRecourseAnnualFSMissing"
                >
                  {{ $t("required_field") }}
                </div>
              </div>
            </b-col>

            <b-col md="6" class="mt-1">
              <div class="pb-0 font-weight-bolder">
                {{ $t("bank_statement_90_days") }}
                <span class="text-danger asterik-size">*</span>
              </div>
              <b-form-file
                style="display: none"
                @change="uploadRecourseFile($event, 'bank_statement', index)"
                :placeholder="$t('upload_files_here')"
                drop-placeholder="Drop file here..."
                :ref="'fileInputBS' + index"
                :id="'fileInputBS' + index"
                v-model.trim="invoice.bank_statement"
                multiple
              ></b-form-file>
              <div class="mt-1 mr-0 pr-0">
                <b-alert show variant="info" class="col-md-8">
                  <b-row class="col-md-12">
                    <b-col
                      class="col-md-12 mt-2 mb-2 text-center pointer"
                      @click="triggerFileInputBS(index)"
                    >
                      <div>
                        <feather-icon icon="DownloadIcon" size="25" />
                        <span></span>
                        {{ $t("upload_files_here") }}
                      </div>
                    </b-col>
                  </b-row>
                </b-alert>
                <ul>
                  <li v-for="(name, i) in filesNameBankStatement" :key="i">
                    {{ name }}
                  </li>
                </ul>
                <div
                  class="col-12 pl-0 text-danger"
                  v-if="nonRecourseBanksStatementMissing"
                >
                  {{ $t("required_field") }}
                </div>
              </div>
            </b-col>
          </b-row>

          <!-- Interim Financial Statements (strongly recommended, non‑blocking) -->
          <div class="pb-0 font-weight-bolder mt-2">
            {{ $t("interim_financial_statements_optional") }}
            <span class="text-warning asterik-size">*</span>
          </div>
          <b-col md="6" class="mt-1 pl-0">
            <b-form-file
              style="display: none"
              @change="uploadRecourseFile($event, 'interim_financial_statements', index)"
              :placeholder="$t('upload_files_here')"
              drop-placeholder="Drop file here..."
              :ref="'fileInputIFS' + index"
              :id="'fileInputIFS' + index"
              v-model.trim="invoice.interim_financial_statements"
              multiple
            ></b-form-file>
            <div class="mt-1 mr-0 pr-0">
              <b-alert show variant="info" class="col-md-8">
                <b-row class="col-md-12">
                  <b-col
                    class="col-md-12 mt-2 mb-2 text-center pointer"
                    @click="triggerFileInputIFS(index)"
                  >
                    <div>
                      <feather-icon icon="DownloadIcon" size="25" />
                      <span></span>
                      {{ $t("upload_files_here") }}
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <ul>
                <li
                  v-for="(name, i) in filesNameInterimFinancialStatements"
                  :key="i"
                >
                  {{ name }}
                </li>
              </ul>
            </div>
          </b-col>

          <!-- Evidence of receivable (1‑of‑N) -->
          <div class="pb-0 font-weight-bolder mt-3">
            {{ $t("evidence_of_receivable_at_least_one") }}
            <span class="text-muted asterik-size">*</span>
          </div>
          <b-row class="mt-1">
            <b-col md="6" class="mt-1">
              <div class="pb-0 font-weight-bolder">
                {{ $t("master_agreement") }}
                <span class="text-muted asterik-size">*</span>
              </div>
              <b-form-file
                style="display: none"
                @change="uploadRecourseFile($event, 'master_agreement', index)"
                :placeholder="$t('upload_files_here')"
                drop-placeholder="Drop file here..."
                :ref="'fileInputMA' + index"
                :id="'fileInputMA' + index"
                v-model.trim="invoice.master_agreement"
                multiple
              ></b-form-file>
              <div class="mt-1 mr-0 pr-0">
                <b-alert show variant="info" class="col-md-8">
                  <b-row class="col-md-12">
                    <b-col
                      class="col-md-12 mt-2 mb-2 text-center pointer"
                      @click="triggerFileInputMA(index)"
                    >
                      <div>
                        <feather-icon icon="DownloadIcon" size="25" />
                        <span></span>
                        {{ $t("upload_files_here") }}
                      </div>
                    </b-col>
                  </b-row>
                </b-alert>
                <ul>
                  <li v-for="(name, i) in filesNameMasterAgreement" :key="i">
                    {{ name }}
                  </li>
                </ul>
              </div>
            </b-col>

            <b-col md="6" class="mt-1">
              <div class="pb-0 font-weight-bolder">
                {{ $t("purchase_order") }}
                <span class="text-muted asterik-size">*</span>
              </div>
              <b-form-file
                style="display: none"
                @change="uploadRecourseFile($event, 'purchase_order', index)"
                :placeholder="$t('upload_files_here')"
                drop-placeholder="Drop file here..."
                :ref="'fileInputPO' + index"
                :id="'fileInputPO' + index"
                v-model.trim="invoice.purchase_order"
                multiple
              ></b-form-file>
              <div class="mt-1 mr-0 pr-0">
                <b-alert show variant="info" class="col-md-8">
                  <b-row class="col-md-12">
                    <b-col
                      class="col-md-12 mt-2 mb-2 text-center pointer"
                      @click="triggerFileInputPO(index)"
                    >
                      <div>
                        <feather-icon icon="DownloadIcon" size="25" />
                        <span></span>
                        {{ $t("upload_files_here") }}
                      </div>
                    </b-col>
                  </b-row>
                </b-alert>
                <ul>
                  <li v-for="(name, i) in filesNamePurchaseOrder" :key="i">
                    {{ name }}
                  </li>
                </ul>
              </div>
            </b-col>

            <b-col md="6" class="mt-1">
              <div class="pb-0 font-weight-bolder">
                {{ $t("delivery_confirmation") }}
                <span class="text-muted asterik-size">*</span>
              </div>
              <b-form-file
                style="display: none"
                @change="uploadRecourseFile($event, 'delivery_confirmation', index)"
                :placeholder="$t('upload_files_here')"
                drop-placeholder="Drop file here..."
                :ref="'fileInputDC' + index"
                :id="'fileInputDC' + index"
                v-model.trim="invoice.delivery_confirmation"
                multiple
              ></b-form-file>
              <div class="mt-1 mr-0 pr-0">
                <b-alert show variant="info" class="col-md-8">
                  <b-row class="col-md-12">
                    <b-col
                      class="col-md-12 mt-2 mb-2 text-center pointer"
                      @click="triggerFileInputDC(index)"
                    >
                      <div>
                        <feather-icon icon="DownloadIcon" size="25" />
                        <span></span>
                        {{ $t("upload_files_here") }}
                      </div>
                    </b-col>
                  </b-row>
                </b-alert>
                <ul>
                  <li
                    v-for="(name, i) in filesNameDeliveryConfirmation"
                    :key="i"
                  >
                    {{ name }}
                  </li>
                </ul>
              </div>
            </b-col>

            <b-col md="6" class="mt-1">
              <div class="pb-0 font-weight-bolder">
                {{ $t("statement_of_work") }}
                <span class="text-muted asterik-size">*</span>
              </div>
              <b-form-file
                style="display: none"
                @change="uploadRecourseFile($event, 'statement_of_work', index)"
                :placeholder="$t('upload_files_here')"
                drop-placeholder="Drop file here..."
                :ref="'fileInputSOW' + index"
                :id="'fileInputSOW' + index"
                v-model.trim="invoice.statement_of_work"
                multiple
              ></b-form-file>
              <div class="mt-1 mr-0 pr-0">
                <b-alert show variant="info" class="col-md-8">
                  <b-row class="col-md-12">
                    <b-col
                      class="col-md-12 mt-2 mb-2 text-center pointer"
                      @click="triggerFileInputSOW(index)"
                    >
                      <div>
                        <feather-icon icon="DownloadIcon" size="25" />
                        <span></span>
                        {{ $t("upload_files_here") }}
                      </div>
                    </b-col>
                  </b-row>
                </b-alert>
                <ul>
                  <li v-for="(name, i) in filesNameStatementOfWork" :key="i">
                    {{ name }}
                  </li>
                </ul>
              </div>
            </b-col>
          </b-row>
          <div class="col-12 pl-0 text-danger" v-if="nonRecourseEvidenceMissing">
            {{ $t("upload_at_least_one_file") }}
          </div>

          <!-- Legend for asterisk meanings -->
          <div class="col-12 pl-0 pt-2 mt-1">
            <small style="display: flex; gap: 3px;">
              <span class="text-danger asterik-size">*</span>
              {{ $t("non_recourse_required_hint") }}
            </small>
            <small style="display: flex; gap: 3px;">
              <span class="text-warning asterik-size">*</span>
              {{ $t("non_recourse_strongly_recommended_hint") }}
            </small>
            <small style="display: flex; gap: 3px;">
              <span class="text-muted asterik-size">*</span>
              {{ $t("non_recourse_evidence_hint") }}
            </small>
          </div>
        </template>
      </div>
    </div>

    <!-- Recourse / Reverse documents, legal text and acceptance -->
    <div v-if="invoice.recourse == 1 || invoice.recourse == 2">
      <div class="col-12 alert alert-secondary p-2">
        <!-- Mandatory documents for Recourse/Reverse -->
        <b-row class="mt-1">
          <b-col md="6" class="mt-1">
            <div class="pb-0 font-weight-bolder">
              {{ $t("annual_financial_statements") }}
              <span class="text-danger asterik-size">*</span>
            </div>
            <b-form-file
              style="display: none"
              @change="uploadRecourseFile($event, 'annual_financial_statements', index)"
              :placeholder="$t('upload_files_here')"
              drop-placeholder="Drop file here..."
              :ref="'fileInputAFS' + index"
              :id="'fileInputAFS' + index"
              v-model.trim="invoice.annual_financial_statements"
              multiple
            ></b-form-file>
            <div class="mt-1 mr-0 pr-0">
              <b-alert show variant="info" class="col-md-8">
                <b-row class="col-md-12">
                  <b-col
                    class="col-md-12 mt-2 mb-2 text-center pointer"
                    @click="triggerFileInputAFS(index)"
                  >
                    <div>
                      <feather-icon icon="DownloadIcon" size="25" />
                      <span></span>
                      {{ $t("upload_files_here") }}
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <ul>
                <li
                  v-for="(name, i) in filesNameAnnualFinancialStatements"
                  :key="i"
                >
                  {{ name }}
                </li>
              </ul>
              <div
                class="col-12 pl-0 text-danger"
                v-if="recourseAnnualFSMissing"
              >
                {{ $t("required_field") }}
              </div>
            </div>
          </b-col>

          <b-col md="6" class="mt-1">
            <div class="pb-0 font-weight-bolder">
              {{ $t("bank_statement_90_days") }}
              <span class="text-danger asterik-size">*</span>
            </div>
            <b-form-file
              style="display: none"
              @change="uploadRecourseFile($event, 'bank_statement', index)"
              :placeholder="$t('upload_files_here')"
              drop-placeholder="Drop file here..."
              :ref="'fileInputBS' + index"
              :id="'fileInputBS' + index"
              v-model.trim="invoice.bank_statement"
              multiple
            ></b-form-file>
            <div class="mt-1 mr-0 pr-0">
              <b-alert show variant="info" class="col-md-8">
                <b-row class="col-md-12">
                  <b-col
                    class="col-md-12 mt-2 mb-2 text-center pointer"
                    @click="triggerFileInputBS(index)"
                  >
                    <div>
                      <feather-icon icon="DownloadIcon" size="25" />
                      <span></span>
                      {{ $t("upload_files_here") }}
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <ul>
                <li v-for="(name, i) in filesNameBankStatement" :key="i">
                  {{ name }}
                </li>
              </ul>
              <div
                class="col-12 pl-0 text-danger"
                v-if="recourseBankStatementMissing"
              >
                {{ $t("required_field") }}
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- Interim Financial Statements (strongly recommended) -->
        <div class="pb-0 font-weight-bolder mt-2">
          {{ $t("interim_financial_statements_optional") }}
          <span class="text-warning asterik-size">*</span>
        </div>
        <b-col md="6" class="mt-1 pl-0">
          <b-form-file
            style="display: none"
            @change="uploadRecourseFile($event, 'interim_financial_statements', index)"
            :placeholder="$t('upload_files_here')"
            drop-placeholder="Drop file here..."
            :ref="'fileInputIFS' + index"
            :id="'fileInputIFS' + index"
            v-model.trim="invoice.interim_financial_statements"
            multiple
          ></b-form-file>
          <div class="mt-1 mr-0 pr-0">
            <b-alert show variant="info" class="col-md-8">
              <b-row class="col-md-12">
                <b-col
                  class="col-md-12 mt-2 mb-2 text-center pointer"
                  @click="triggerFileInputIFS(index)"
                >
                  <div>
                    <feather-icon icon="DownloadIcon" size="25" />
                    <span></span>
                    {{ $t("upload_files_here") }}
                  </div>
                </b-col>
              </b-row>
            </b-alert>
            <ul>
              <li
                v-for="(name, i) in filesNameInterimFinancialStatements"
                :key="i"
              >
                {{ name }}
              </li>
            </ul>
          </div>
        </b-col>

        <!-- Optional supporting documents -->
        <div class="pb-0 font-weight-bolder mt-3">
          {{ $t("optional_supporting_documents") }}
        </div>
        <b-row class="mt-1">
          <b-col md="6" class="mt-1">
            <div class="pb-0 font-weight-bolder">
              {{ $t("master_agreement") }}
              <span class="text-muted asterik-size">*</span>
            </div>
            <b-form-file
              style="display: none"
              @change="uploadRecourseFile($event, 'master_agreement', index)"
              :placeholder="$t('upload_files_here')"
              drop-placeholder="Drop file here..."
              :ref="'fileInputMA' + index"
              :id="'fileInputMA' + index"
              v-model.trim="invoice.master_agreement"
              multiple
            ></b-form-file>
            <div class="mt-1 mr-0 pr-0">
              <b-alert show variant="info" class="col-md-8">
                <b-row class="col-md-12">
                  <b-col
                    class="col-md-12 mt-2 mb-2 text-center pointer"
                    @click="triggerFileInputMA(index)"
                  >
                    <div>
                      <feather-icon icon="DownloadIcon" size="25" />
                      <span></span>
                      {{ $t("upload_files_here") }}
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <ul>
                <li v-for="(name, i) in filesNameMasterAgreement" :key="i">
                  {{ name }}
                </li>
              </ul>
            </div>
          </b-col>

          <b-col md="6" class="mt-1">
            <div class="pb-0 font-weight-bolder">
              {{ $t("purchase_order") }}
              <span class="text-muted asterik-size">*</span>
            </div>
            <b-form-file
              style="display: none"
              @change="uploadRecourseFile($event, 'purchase_order', index)"
              :placeholder="$t('upload_files_here')"
              drop-placeholder="Drop file here..."
              :ref="'fileInputPO' + index"
              :id="'fileInputPO' + index"
              v-model.trim="invoice.purchase_order"
              multiple
            ></b-form-file>
            <div class="mt-1 mr-0 pr-0">
              <b-alert show variant="info" class="col-md-8">
                <b-row class="col-md-12">
                  <b-col
                    class="col-md-12 mt-2 mb-2 text-center pointer"
                    @click="triggerFileInputPO(index)"
                  >
                    <div>
                      <feather-icon icon="DownloadIcon" size="25" />
                      <span></span>
                      {{ $t("upload_files_here") }}
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <ul>
                <li v-for="(name, i) in filesNamePurchaseOrder" :key="i">
                  {{ name }}
                </li>
              </ul>
            </div>
          </b-col>

          <b-col md="6" class="mt-1">
            <div class="pb-0 font-weight-bolder">
              {{ $t("delivery_confirmation") }}
              <span class="text-muted asterik-size">*</span>
            </div>
            <b-form-file
              style="display: none"
              @change="uploadRecourseFile($event, 'delivery_confirmation', index)"
              :placeholder="$t('upload_files_here')"
              drop-placeholder="Drop file here..."
              :ref="'fileInputDC' + index"
              :id="'fileInputDC' + index"
              v-model.trim="invoice.delivery_confirmation"
              multiple
            ></b-form-file>
            <div class="mt-1 mr-0 pr-0">
              <b-alert show variant="info" class="col-md-8">
                <b-row class="col-md-12">
                  <b-col
                    class="col-md-12 mt-2 mb-2 text-center pointer"
                    @click="triggerFileInputDC(index)"
                  >
                    <div>
                      <feather-icon icon="DownloadIcon" size="25" />
                      <span></span>
                      {{ $t("upload_files_here") }}
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <ul>
                <li v-for="(name, i) in filesNameDeliveryConfirmation" :key="i">
                  {{ name }}
                </li>
              </ul>
            </div>
          </b-col>

          <b-col md="6" class="mt-1">
            <div class="pb-0 font-weight-bolder">
              {{ $t("statement_of_work") }}
              <span class="text-muted asterik-size">*</span>
            </div>
            <b-form-file
              style="display: none"
              @change="uploadRecourseFile($event, 'statement_of_work', index)"
              :placeholder="$t('upload_files_here')"
              drop-placeholder="Drop file here..."
              :ref="'fileInputSOW' + index"
              :id="'fileInputSOW' + index"
              v-model.trim="invoice.statement_of_work"
              multiple
            ></b-form-file>
            <div class="mt-1 mr-0 pr-0">
              <b-alert show variant="info" class="col-md-8">
                <b-row class="col-md-12">
                  <b-col
                    class="col-md-12 mt-2 mb-2 text-center pointer"
                    @click="triggerFileInputSOW(index)"
                  >
                    <div>
                      <feather-icon icon="DownloadIcon" size="25" />
                      <span></span>
                      {{ $t("upload_files_here") }}
                    </div>
                  </b-col>
                </b-row>
              </b-alert>
              <ul>
                <li v-for="(name, i) in filesNameStatementOfWork" :key="i">
                  {{ name }}
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>

        <!-- Legal text and acceptance -->
        <template v-if="invoice.recourse == 2">
          <div class="pt-2" v-if="$store.state.app.language === 'en'">
            I hereby confirm the following agreement within the framework of
            reverse factoring:
            <br />
            <br />
            1.1 The contractual partner (debtor) transfers its liabilities from
            deliveries and services to the invoice purchaser (factor). This
            invoice purchaser (factor) shall assume these liabilities on account
            of fulfilment subject to clauses 1.2 and 1.3 of this agreement.
            <br />
            <br />
            1.2 This is a case of reverse factoring. This means that the
            contractual partner (debtor) retains the default risk for the
            transferred liabilities.
            <br />
            <br />
            1.3 The contractual partner (debtor) pays the amount of its
            liability to Aequitex AG. The contractual partner (debtor)
            transfers the full amount of his liabilities to Aequitex AG on the
            due date stated on the invoice (credit note required).
            <br />
            <br />
            1.4 The contractual partner (debtor) assumes all costs arising from
            his payment default, including reminder and collection costs.
          </div>
          <div class="pt-2" v-else-if="$store.state.app.language === 'de'">
            Hiermit bestätige ich folgende Vereinbarung im Rahmen des
            Reverse-Factorings:
            <br />
            <br />
            1.1 Der Vertragspartner (Debtor) übergibt seine Verbindlichkeiten
            aus Lieferungen und Leistungen an den Rechnungskäufer (Factor) ab.
            Dieser Rechnungskäufer (Factor) übernimmt diese Verbindlichkeiten
            erfüllungshalber vorbehaltlich Ziff. 1.2 und 1.3 dieses Vertrages.
            <br />
            <br />
            1.2 Es handelt sich um ein Reverse Factoring. Das bedeutet, dass
            der Vertragspartner (Debtor) das Ausfallrisiko für die übergebenen
            Verbindlichkeiten behält.
            <br />
            <br />
            1.3 Der Vertragspartner (Debtor) begleicht den Betrag seiner
            Verbindlichkeit an die Aequitex AG. Der Vertragspartner (Debtor)
            überweist Aequitex AG den vollen Betrag seiner Verbindlichkeiten
            zum auf der Rechnung angegebenen Fälligkeitsdatum (Gutschrift
            erforderlich).
            <br />
            <br />
            1.4 Der Vertragspartner (Debtor) übernimmt alle Kosten, die durch
            seinen Zahlungsausfall entstehen, einschließlich Mahn- und
            Inkassokosten.
          </div>
        </template>
        <template v-else>
          <div class="pt-2" v-if="$store.state.app.language == 'en'">
            I hereby confirm the following agreement within the framework of
            recourse factoring:
            <br />
            <br />
            1.1 The Seller transfers its receivables from deliveries and
            services to the Buyer. The Buyer assumes these receivables on
            account of fulfilment subject to Clause 1.2 and § 3 of this
            agreement.
            <br />
            <br />
            1.2 This is a case of recourse factoring. This means that the
            seller assumes the default risk for the assigned receivables.
            <br />
            <br />
            1.3 The debtor pays the amount of the claim to the seller. The
            seller then forwards the claim amount received from the debtor to
            the buyer within 3 days of receipt.
            <br />
            <br />
            1.4 If the debtor has not paid the amount of the claim to the
            seller by the due date, the seller shall pay the amount of the
            claim to the buyer no later than the third day after the due date
            (credit note required).
            <br />
            <br />
            1.5 The Seller shall bear all costs incurred as a result of
            non-payment, including reminder and collection costs.
          </div>
          <div class="pt-2" v-else-if="$store.state.app.language == 'de'">
            Hiermit bestätige ich folgende Vereinbarung im Rahmen des
            Recourse-Factoring:
            <br />
            <br />
            1.1 Der Verkäufer überträgt seine Forderungen aus Lieferungen und
            Leistungen an den Käufer. Der Käufer übernimmt diese Forderungen
            erfüllungshalber vorbehaltlich Ziff. 1.2 und § 3 dieses Vertrages.
            <br />
            <br />
            1.2 Es handelt sich um ein Recourse Factoring. Das bedeutet, dass
            der Verkäufer das Ausfallrisiko für die abgetretenen Forderungen
            übernimmt.
            <br />
            <br />
            1.3 Der Schuldner begleicht den Forderungsbetrag an den Verkäufer.
            Der Verkäufer leitet dann, den durch den Schuldner erhaltenen
            Forderungsbetrag, innerhalb von 3 Tagen nach Erhalt an den Käufer
            weiter.
            <br />
            <br />
            1.4 Falls der Schuldner den Forderungsbetrag bis zum
            Fälligkeitsdatum nicht an den Verkäufer beglichen haben sollte,
            begleicht der Verkäufer den Forderungsbetrag gegenüber dem Käufer
            spätestens am dritten Tag nach dem Fälligkeitsdatum (Gutschrift
            erforderlich).
            <br />
            <br />
            1.5 Der Verkäufer übernimmt alle Kosten, die durch einen
            Zahlungsausfall entstehen, einschließlich Mahn- und Inkassokosten.
          </div>
        </template>

        <b-row class="col-12 pl-0 pt-2 align-items-end">
          <b-form-group class="col-8" v-if="invoice.recourse == 1">
            <validation-provider
              #default="{ errors }"
              rules="required"
              :name="'accept recourse '"
              :id="'accept_recourse' + '' + index"
            >
              <b-form-checkbox
                v-model.trim="invoice.accept_recourse"
                @change="changeInvoiceFact(invoice, index)"
                required
                :state="errors.length > 0 ? false : null"
                :name="'accept recourse ' + index"
              >
                <span>
                  {{ $t("accept") }}
                </span>
              </b-form-checkbox>
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group class="col-8" v-else-if="invoice.recourse == 2">
            <validation-provider
              #default="{ errors }"
              rules="required"
              :name="'accept reverse '"
              :id="'accept_reverse' + '' + index"
            >
              <b-form-checkbox
                v-model.trim="invoice.acceptReverse"
                @change="acceptReverseChange"
                :state="acceptReverseError ? false : null"
                :disabled="invoice.status != 0"
                :name="'accept reverse ' + index"
                required
              >
                <span>
                  {{ $t("accept") }}
                </span>
              </b-form-checkbox>
              <small class="text-danger" v-if="acceptReverseError">
                {{ $t("This field is required") }}
              </small>
            </validation-provider>
          </b-form-group>

          <!-- Legend for asterisk meanings for Recourse/Reverse -->
          <div class="col-4 pl-0">
            <small style="display: flex; gap: 3px;">
              <span class="text-danger asterik-size">*</span>
              {{ $t("non_recourse_required_hint") }}
            </small>
            <small style="display: flex; gap: 3px;">
              <span class="text-warning asterik-size">*</span>
              {{ $t("non_recourse_strongly_recommended_hint") }}
            </small>
            <small style="display: flex; gap: 3px;">
              <span class="text-muted asterik-size">*</span>
              {{ $t("recourse_optional_supporting_hint") }}
            </small>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "InvoiceDocuments",
  components: {
    ValidationProvider,
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    // flags from parent
    nonRecourseAnnualFSMissing: {
      type: Boolean,
      default: false,
    },
    nonRecourseBanksStatementMissing: {
      type: Boolean,
      default: false,
    },
    nonRecourseEvidenceMissing: {
      type: Boolean,
      default: false,
    },
    recourseAnnualFSMissing: {
      type: Boolean,
      default: false,
    },
    recourseBankStatementMissing: {
      type: Boolean,
      default: false,
    },
    supportingDocsFilesMissing: {
      type: Boolean,
      default: false,
    },
    // file name lists from parent
    filesNameSupporting: {
      type: Array,
      default: () => [],
    },
    filesNameAnnualFinancialStatements: {
      type: Array,
      default: () => [],
    },
    filesNameBankStatement: {
      type: Array,
      default: () => [],
    },
    filesNameInterimFinancialStatements: {
      type: Array,
      default: () => [],
    },
    filesNameMasterAgreement: {
      type: Array,
      default: () => [],
    },
    filesNamePurchaseOrder: {
      type: Array,
      default: () => [],
    },
    filesNameDeliveryConfirmation: {
      type: Array,
      default: () => [],
    },
    filesNameStatementOfWork: {
      type: Array,
      default: () => [],
    },
    // methods passed from parent
    uploadRecourseFile: {
      type: Function,
      required: true,
    },
    triggerFileInput5: {
      type: Function,
      required: true,
    },
    triggerFileInputAFS: {
      type: Function,
      required: true,
    },
    triggerFileInputBS: {
      type: Function,
      required: true,
    },
    triggerFileInputIFS: {
      type: Function,
      required: true,
    },
    triggerFileInputMA: {
      type: Function,
      required: true,
    },
    triggerFileInputPO: {
      type: Function,
      required: true,
    },
    triggerFileInputDC: {
      type: Function,
      required: true,
    },
    triggerFileInputSOW: {
      type: Function,
      required: true,
    },
    changeInvoiceFact: {
      type: Function,
      required: true,
    },
    acceptReverseChange: {
      type: Function,
      required: true,
    },
    acceptReverseError: {
      type: Boolean,
      default: true,
    },
  },
};
</script>


